module.exports = __webpack_public_path__ + "media/images/arrows/twisted/green-left2-4362aa71de457bd0fda23c7a1b01c404.svg";